import { gql } from "graphql-request";

export const VERIFY_USER = gql`
  query Verify {
    verify {
      id
      first_name
      last_name
      email
      phone
      department
      position
      is_active
      img_url
      last_login_date
      role_list {
        id
        name
        description
        permission_list
        accessible_template_list {
          template_id
          template_priviledge
        }
      }
    }
  }
`;
